import React, { useContext, useState } from 'react';
import Modal from 'react-overlays/Modal';
import styled from 'styled-components';
import { SegmentWithHeader } from '@app/shared';
import { ScrollableContentContainer } from '../../tms/components/ScrollableContentContainer';
import { JsonViewer } from '@textea/json-viewer';
import { AccountContext } from '../AccountContext';
import { useAccountById, useGetProduct, useProductConfig } from '@app/sdk';
import { Item } from '../../../shared/Item';

const ProductDetailsModal = styled(Modal)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: fit-content;
  z-index: 1040;
  background-color: white;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
`;

export default function ProductDetails() {
  const [popupVisible, setPopupVisible] = useState(false);

  const { accountId } = useContext(AccountContext);

  const { data: account } = useAccountById(accountId);
  const { data: product } = useGetProduct({ productId: account?.productId });
  const { data: productConfig } = useProductConfig({
    productId: account?.productId,
  });

  const closePopup = () => {
    setPopupVisible(false);
  };

  return (
    <>
      <Item header={'Product:'} description={product?.description}></Item>
      <button onClick={() => setPopupVisible(true)} className={'ui button'}>
        View Product Config
      </button>

      <ProductDetailsModal show={popupVisible} aria-labelledby="modal-label">
        <SegmentWithHeader header={`Product: ${product?.label}`} onClose={closePopup} className={'basic'}>
          <ScrollableContentContainer className={'basic'} height={'300px'} style={{ border: 'thin solid lightgray' }}>
            <JsonViewer value={productConfig} />
          </ScrollableContentContainer>
        </SegmentWithHeader>
      </ProductDetailsModal>
    </>
  );
}
